import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentstModule } from '../../../shared/components/components.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ValeEstarBemComponent } from './vale-estar-bem.component';
import { ValeEstarBemRoutingModule } from './vale-estar-bem-routing.module';
import { GestaoBeneficiarioComponent } from './gestao-beneficiario/gestao-beneficiario.component';

@NgModule({
  imports: [
    CommonModule,
    ValeEstarBemRoutingModule,
    NbCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    ComponentstModule,
    CurrencyMaskModule, 
  ],
  exports: [
    MyDatePickerModule,
  ],
  entryComponents: [       
  ],
  declarations: [
    ValeEstarBemComponent,    
    GestaoBeneficiarioComponent
  ],
})

export class ValeEstarBemModule { }
